import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import { listProject, unloadProjectList } from '../../modules/project/projectsSlice';

import ProjectList from './ProjectList';
import { unloadProject } from '../../modules/project/projectSlice';

const ProjectListContainer = () => {
    const { username } = useParams();
    const [searchParams] = useSearchParams();
    const dispatch = useDispatch();
    // const { projects, error, loading, user } = useSelector(({ projects, loading, user }) => ({
    //     projects: projects.projects,
    //     error: projects.error,
    //     loading: loading['projects/LIST_PROJECTS'],
    //     user: user.user,
    // }));

    const projects = useSelector(state => state.projects.projects);
    const error = useSelector(state => state.projects.error);
    const loading = useSelector(state => state.loading);
    const user = useSelector(state => state.user.user);

    useEffect(() => {
        const tag = searchParams.get('tag');
        // page가 없으면 1을 기본값으로 사용
        const page = parseInt(searchParams.get('page'), 10) || 1;
        dispatch(listProject({ tag, username, page }));

        try {
            localStorage.removeItem('project');
        } catch (err) {
            console.error(err);
        }
    }, [dispatch, searchParams, username]);

    /** 중요!!!
     *  마운트될 때 리덕스에서 프로젝트 정보를 지운다. 프로젝트 Container가 언마운트할 때 지우는 것이 맞는 방법이지만
     *  그렇게 하면 conveyor list등 프로젝트 정보가 필요할 때 localStorage 등을 사용해야 한다. 
     */
    useEffect(() => {
        dispatch(unloadProject());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        // 언마운트될 때 리덕스에서 프로젝트 리스트 없애기
        return () => {
            dispatch(unloadProjectList());
        };
    }, [dispatch]);

    return <ProjectList loading={!loading} error={error} projects={projects} user={user} />;
};

export default ProjectListContainer;
